// ── Accounts are created in Sales, not here ──────────────────────────────────
// Shown instead of a creation form when someone clicks "+ Add Account".
//
// The button is kept rather than removed: someone looking for it should find out
// where accounts come from, not an absence they have to interpret.
import { Modal, Btn } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const AccountCreateNotice = ({ canGoToSales, onGoToSales }) => {
  const { closeModal } = useApp();

  return (
    <Modal title="Accounts are created in Sales" onClose={closeModal}>
      <p style={{ fontSize: 14, marginTop: 0, marginBottom: 18 }}>
        New companies enter the platform through the <strong>Sales Platform</strong>, as a
        lead that is then converted. That conversion creates the account record this app
        works from.
      </p>

      <p style={{ fontSize: 13, color: "var(--color-text-secondary)", marginBottom: 18 }}>
        {canGoToSales
          ? <>Create the lead in Sales, then convert it once the deal is real.</>
          : <>If you do not work in Sales, ask whoever owns the relationship to create the lead.</>}
      </p>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={closeModal}>Close</Btn>
        {canGoToSales && <Btn variant="primary" onClick={onGoToSales}>Go to Sales Platform</Btn>}
      </div>
    </Modal>
  );
};
